module.exports = __webpack_public_path__ + "img/message-letter.844ec698.png";